export const TRACKS_ENDPOINTS = {
  BASE: "/v1/tracks",
  DETAIL: (id: string) => `/v1/tracks/${id}`,
} as const;
